type DeclinationReason = {
  value: string;
  label: string;
  requiredAdditional: Array<string>;
};

export const DECLINATION_REASONS: Array<DeclinationReason> = [
  {
    value: "spouse_parent_plan",
    label: "Covered by spouse's or parent's plan",
    requiredAdditional: ["declinationReason1CarrierName", "declinationReason1IDNumber"],
  },

  {
    value: "tricare_plan",
    label: "Covered by Tricare",
    requiredAdditional: ["declinationReason1CarrierName", "declinationReason1IDNumber"],
  },

  {
    value: "government_plan",
    label: "Covered under government plan (Medicare, Medicaid, etc)",
    requiredAdditional: ["declinationReason1CarrierName", "declinationReason1IDNumber"],
  },

  {
    value: "other_employer_plan",
    label: "Covered by another employer's health plan",
    requiredAdditional: ["declinationReason1CarrierName", "declinationReason1IDNumber"],
  },

  {
    value: "individual_insurance_plan",
    label: "Covered by individual insurance",
    requiredAdditional: ["declinationReason1CarrierName", "declinationReason1IDNumber"],
  },

  {
    value: "obamacare_aca_plan",
    label: "Covered by subsidized Obamacare/Affordable Care Act plan",
    requiredAdditional: ["declinationReason1CarrierName", "declinationReason1IDNumber"],
  },

  {
    value: "other",
    label: "None of these apply to me",
    requiredAdditional: ["declinationReason4Explanation"],
  },
];
